module.exports = __webpack_public_path__ + "img/schiffchen-2.ee13c5f4.jpg";